import { Provider } from "react-redux";
import { myStore } from "./store";

export default function StoreProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  // const storeRef = useRef<AppStore>(undefined);
  // if (!storeRef.current) {
  //   storeRef.current = myStore();
  // }

  return <Provider store={myStore}>{children}</Provider>;
}
